export const MAX_DOWNLOAD_SIZE_BYTES = 500 * 1024 * 1024; // 500 MB

// Sliding-window concurrency for file downloads. Unlike a fixed batch (Promise.all per
// batch), a sliding window immediately fills a free slot when any file finishes, so a
// single slow/large file cannot stall all remaining downloads while the rest of the batch
// waits for it.
export const DOWNLOAD_BATCH_SIZE = 8;

// Max number of concurrent HEAD requests used to compute the total download size before
// starting the actual download. Previously this was unbounded (Promise.all over all files),
// which we suspect triggered CDN rate limiting and caused subsequent download failures.
// Capping at 20 keeps the size-check fast while avoiding a burst of hundreds of requests.
export const HEAD_REQUEST_CONCURRENCY = 20;

// Only retry on network-level errors (TypeError — e.g. connection reset, DNS failure).
// HTTP errors (4xx / 5xx) are deterministic; retrying them will not help.
export const FETCH_MAX_RETRIES = 2;
export const FETCH_RETRY_DELAY_MS = 1000;
